import React, { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { GET_TEAM_MEMBERS } from "../graphql/queries";
import gsap from "gsap";

export default function Team() {
    const { loading, error, data } = useQuery(GET_TEAM_MEMBERS);
    const teamMembersRef = useRef([]);

    useEffect(() => {
        if (!loading && !error && data) {
            gsap.fromTo(
                teamMembersRef.current,
                { opacity: 0, y: 20 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.2,
                    stagger: 0.2,
                }
            );
        }
    }, [loading, error, data]);

    if (loading) return <p>Loading...</p>;
    if (error) {
        console.error(error);
        return <p>Error : {error.message}</p>;
    }

    return (
        <div className="main-container">
            <div className="posts-header">
                <div className="post-content">
                    <h1>Meet the team</h1>
                    <div className="purple-line"></div>
                </div>
            </div>
            <div className="team-members">
                {data.teams.map((member, index) => (
                    <div
                        key={member.id || member.name}
                        className="team-member"
                        ref={(el) => (teamMembersRef.current[index] = el)}
                        style={{ backgroundImage: `url(${member.image.url})` }}
                    >
                        <div className="member-content">
                            <h3>{member.name}</h3>
                            <p>{member.rol}</p>
                            {member.docents &&
                                member.docents.map((docent, i) => (
                                    <p key={i}>{docent.programma}</p>
                                ))}
                        </div>
                        <div className="gradient"></div>
                    </div>
                ))}
            </div>
        </div>
    );
}
